export const CART_EVENT_LOCATION = "bag";
export const ITEM_TARGET = "item";
export const ITEM_EDIT_TARGET = "item_edit";
export const CHECKOUT_TARGET = "checkout";
export const CONTINUE_SHOPPING_TARGET = "continue_shopping";
